














import Vue from 'vue';
import BaseButton from './BaseButton.vue';
import { mapState as mapRootState } from 'vuex';

export default Vue.extend({
    components: { BaseButton },
    props: {
        isSelected: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'label',
        },
        size: {
            type: String,
            default: 'big',
        },
        title: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
    computed: {
        ...mapRootState(['portalBranding']),
    },
});
